import { useTheme } from '@mui/material/styles';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import Link from 'next/link';
import { nanoid } from 'nanoid';
import { useStyles } from './style';

/**
 * @name SecondaryNav
 * @description Displays secondary navgiation links of footer
 * @param {*} param0 - Destructured object
 * @param {object} param0.data - Footer navigation data from strapi
 * @returns {JSX.Element} ReactElement
 */
const SecondaryNav = ({ data }) => {
  const length = data?.Link?.length || 0;
  const leftStack = data?.Link?.slice(0, length / 2);
  const rightStack = data?.Link?.slice(length / 2);
  const theme = useTheme();
  const styles = useStyles(theme);
  const md = useMediaQuery(theme.breakpoints.up('md'));

  return md ? (
    <Grid item xs={12} sx={styles.container}>
      {data?.Link?.map(nav => (
        <Link
          key={nanoid(8)}
          underline='hover'
          component='a'
          href={nav.link}
          aria-label={nav?.ariaLabel}
        >
          <Typography variant='subtitle1' component='p' sx={styles.secondaryNav}>
            {nav?.text}
          </Typography>
        </Link>
      ))}
    </Grid>
  ) : (
    [leftStack, rightStack].map(linkData => (
      <Grid item key={nanoid(8)} xs={6} sx={styles.container}>
        {linkData?.map(nav => (
          <Link
            key={nanoid(8)}
            underline='hover'
            component='a'
            href={nav.link}
            aria-label={nav?.ariaLabel}
          >
            <Typography variant='subtitle1' component='p' sx={styles.mobileNav}>
              {nav?.text}
            </Typography>
          </Link>
        ))}
      </Grid>
    ))
  );
};

export default SecondaryNav;
